module.exports = __webpack_public_path__ + "static/media/cotyBanner-tablet-738x57@2x.6d886aa1.jpg";